import React, { Component } from 'react';
import withRouter from "./components/withRouter"
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import requester from '../library/Requester';
import * as util from '../library/utilitys';
import * as Actions from './actions/ActionCenter';
import CommonImageFrontend from './components/CommonImageFrontend';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import styles from '../styles/frontend/HomePage.css';
import { calendarDays, weekDays } from './FrontendHomepage';
const URL = `public/view/frontent/tops-info`;
const ATTACH_FILE_CONTENT_URL = `public/view/attach_files/files`;
class PublicizePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      itemsPosition: [],
      images: {},
      imagesPosition: {},

      newsGroups: [],
      activeGroupIndex: 0,
      DatatableImage1: {},
      DatatableImage5: {},

      page: 1,
      pageSize: 6,
      source_type: 'vacancy',
      totalPages: 1,
      networks: [],
      networkImages: {},
      courses: [],
      coursePage: 1,
      courseTotalPages: 1,
      DataTableCalendarDetail: [],
      // selectedMonth: this.getMonthName(new Date()),
      currentDate: new Date(),
    };
  }

    async componentDidMount() {
        await this.loadDataToState();
        this.loadPublicizeData();
        this.loadNetworkData();
        this.loadTrainingCourseData();
        this.loadPositionData();

        window.addEventListener('resize', this.handleResize);
        if (window.innerWidth < 768) {
            this.enableSwipeGesture();
            this.enableNewsSwipeGesture();
        }
    }
    
    renderNewsDescription = (groupName) => {
      switch (groupName) {
        case'ข่าวสารทั่วไป':
          return 'ศูนย์กลางข้อมูลข่าวสาร ความก้าวหน้า และโอกาสการพัฒนาทั้งในด้านการลงทุน นวัตกรรม และเศรษฐกิจในเขตพัฒนาพิเศษภาคตะวันออก';

        case'กิจกรรม':
          return 'ติดตามกิจกรรมและความเคลื่อนไหวจากหน่วยงานต่าง ๆ ที่เกี่ยวข้องกับการพัฒนาในพื้นที่ EEC';

        case'สถาบัน':
          return 'ข้อมูลเกี่ยวกับสถาบันการศึกษา หน่วยงานฝึกอบรม และองค์กรที่เกี่ยวข้องกับการส่งเสริมกำลังคนในพื้นที่ EEC';

        case'หลักสูตร':
          return 'หลักสูตรที่ได้รับการพัฒนาเพื่อเตรียมความพร้อมด้านทักษะ และการเรียนรู้ให้สอดคล้องกับอุตสาหกรรมเป้าหมาย';

        case'ฝึกอบรม':
          return 'โอกาสในการเข้าร่วมการฝึกอบรมเพื่อยกระดับศักยภาพแรงงานและผู้ประกอบการในเขตพัฒนาพิเศษภาคตะวันออก';

        case'ตำแหน่งงาน':
          return 'รวมตำแหน่งงานจากหน่วยงานภาครัฐและเอกชนในพื้นที่ EEC ที่เปิดรับสมัคร พร้อมโอกาสด้านอาชีพหลากหลาย';

        default:
          return 'ศูนย์กลางข้อมูลข่าวสาร โอกาสการลงทุน และกิจกรรมที่ส่งเสริมการพัฒนาอย่างยั่งยืนในภาคตะวันออกของประเทศไทย';
      }
    };

    handleResize = () => {
        const isMobile = window.innerWidth < 768;
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
            if (isMobile) this.enableSwipeGesture();
            else if (this.cleanupSwipe) this.cleanupSwipe();
        }
    };

    enableSwipeGesture = () => {
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 50;

        const handleTouchStart = (e) => (touchStartX = e.touches[0].clientX);
        const handleTouchEnd = (e) => {
        touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (diff > swipeThreshold) this.handlePrevBanner();
        else if (diff < -swipeThreshold) this.handleNextBanner();
        };

        this.bannerContainer = document.getElementById("heroBannerContainer");
        if (this.bannerContainer) {
            this.bannerContainer.addEventListener("touchstart", handleTouchStart);
            this.bannerContainer.addEventListener("touchend", handleTouchEnd);
        }

        this.cleanupSwipe = () => {
            if (this.bannerContainer) {
                this.bannerContainer.removeEventListener("touchstart", handleTouchStart);
                this.bannerContainer.removeEventListener("touchend", handleTouchEnd);
            }
        };
    };

    enableNewsSwipeGesture = () => {
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 50;
    
        const handleTouchStart = (e) => (touchStartX = e.touches[0].clientX);
        const handleTouchEnd = (e) => {
            touchEndX = e.changedTouches[0].clientX;
            const diff = touchStartX - touchEndX;
        
            if (diff > swipeThreshold) {
                this.setState((prev) => ({
                activeGroupIndex:
                    (prev.activeGroupIndex - 1 + prev.newsGroups.length) %
                    prev.newsGroups.length,
                }));
            } else if (diff < -swipeThreshold) {
                this.setState((prev) => ({
                activeGroupIndex:
                    (prev.activeGroupIndex + 1) % prev.newsGroups.length,
                }));
            }
        };
    
        this.newsContainer = document.getElementById("newsSectionContainer");
        if (this.newsContainer) {
            this.newsContainer.addEventListener("touchstart", handleTouchStart);
            this.newsContainer.addEventListener("touchend", handleTouchEnd);
        }
    
        this.cleanupNewsSwipe = () => {
            if (this.newsContainer) {
                this.newsContainer.removeEventListener("touchstart", handleTouchStart);
                this.newsContainer.removeEventListener("touchend", handleTouchEnd);
            }
        };
    };
    loadDataToState = async () => {
        const currentThaiYear = new Date().getFullYear() + 543;

        await this.putDataToState("DataTable1", "frontend_publicize_data", true, "DatatableImage1", { pageSize: 100 }, (data) => {
            const grouped = {};
            data.forEach(item => {
                if (!grouped[item.news_type]) grouped[item.news_type] = [];
                grouped[item.news_type].push(item);
            });

            // ใหม่: newsGroups = [{ groupName: 'ชื่อ', items: [] }]
            const limitedGroups = Object.entries(grouped).map(([key, items]) => ({
                groupName: key,
                items: items.slice(0, 4)
            }));

            this.setState({ newsGroups: limitedGroups }, () => {
                if (this.state.isMobile) {
                    if (this.cleanupNewsSwipe) this.cleanupNewsSwipe();
                    this.enableNewsSwipeGesture();
                }
            });
        });
    }

  loadPublicizeData = async () => {
    const { page, pageSize } = this.state;
    try {
      const response = await requester.post(`public/view/frontent/tops-info/frontend_publicize_data`, {
        page,
        pageSize,
        source_type: 'general',
      });
      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      this.setState({ items: data, totalPages: pagination.totalPages || 1 }, () => {
        this.loadImages(data, 'images');
      });
    } catch (error) {
      console.error('Error fetching publicize data:', error);
    }
  };

  loadNetworkData = async () => {
    try {
      const response = await requester.post(`public/view/frontent/tops-info/frontend_eec_net`, {});
      const data = response?.data?.data?.data || [];
      this.setState({ networks: data }, () => {
        this.loadImages(data, 'networkImages');
      });
    } catch (error) {
      console.error('Error fetching network data:', error);
    }
  };

  loadTrainingCourseData = async () => {
    const { coursePage, pageSize } = this.state;
    try {
      const response = await requester.post(`public/view/frontent/tops-info/frontend_all_course`, {
        page: coursePage,
        pageSize
      });
      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      this.setState({ courses: data, courseTotalPages: pagination.totalPages || 1 });

      await this.putDataToState("DataTableCalendarDetail", "frontend_training_course", false, "", { pageSize: 10 });
    } catch (error) {
      console.error('Error fetching training course data:', error);
    }
  };

  loadPositionData = async () => {
    const { page, pageSize, source_type } = this.state;
    try {
      const response = await requester.post(`public/view/frontent/tops-info/frontend_publicize_data`, {
        page,
        pageSize,
        source_type,
      });
      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      this.setState({ itemsPosition: data, totalPages: pagination.totalPages || 1 }, () => {
        this.loadImages(data, 'imagesPosition');
      });
    } catch (error) {
      console.error('Error fetching publicize data:', error);
    }
  };

  loadImages = async (rows, stateKey) => {
    const imageMap = await Actions.loadImageBlobUrls({
      rows,
      fileField: 'photo',
      idField: 'id',
      baseUrl: 'public/view/attach_files/files'
    });
    this.setState({ [stateKey]: imageMap });
  };

  handlePrevPage = () => {
    this.setState(
      (prevState) => ({ page: Math.max(prevState.page - 1, 1) }),
      this.loadPublicizeData
    );
  };

  handleNextPage = () => {
    this.setState((prevState) => {
      if (prevState.page < prevState.totalPages) {
        return { page: prevState.page + 1 };
      }
      return null;
    }, this.loadPublicizeData);
  };

  getMonthName(date) {
    return date.toLocaleString('th-TH', { month: 'long', year: 'numeric' });
  }

  putDataToState = async (stateKey, path, loadImage = false, imageStateKey = "", body = {}, onAfterSetState = null) => {
    try {
      const response = await requester.post(`${URL}/${path}`, body);
      const data = response.data?.data?.data || response.data?.data || [];

      this.setState({ [stateKey]: data }, async () => {
        if (onAfterSetState) {
          onAfterSetState(data);
        }
        if (loadImage) {
          await this.loadImages(data, imageStateKey);   // ← เปลี่ยนจาก stateKey เป็น data
        }
      });
    } catch (error) {
      console.error(`Error loading data for ${stateKey} from ${path}`, error);
    }
  };

  changeMonth = (offset) => {
    this.setState(prev => {
      const newDate = new Date(prev.currentDate);
      newDate.setMonth(newDate.getMonth() + offset);
      return { currentDate: newDate };
    });
  };

  generateCalendarDays = (currentDate, courses) => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const startDay = firstDay.getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate();

    const calendar = [];

    const toDateOnly = (date) => {
      const d = new Date(date);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    //     for (let i = 0; i < startDay; i++) {
    //   calendar.push({ day: '', isOtherMonth: true });
    // }

    for (let i = startDay - 1; i >= 0; i--) {
      calendar.push({
        day: daysInPrevMonth - i,
        isOtherMonth: true,
        hasEvent: false,
      });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const current = new Date(year, month, day);

      const hasEvent = courses.some(c => {
        if (!c.training_start_date || !c.training_end_date) return false;
        const start = toDateOnly(c.training_start_date);
        const end = toDateOnly(c.training_end_date);
        
        return current >= start && current <= end;
      });

      calendar.push({
        day,
        isOtherMonth: false,
        hasEvent,
      });
    }

    const remain = 42 - calendar.length;
    for (let i = 1; i <= remain; i++) {
      calendar.push({
        day: i,
        isOtherMonth: true,
        hasEvent: false,
      });
    }

    return calendar;
  };

  render() {
    const { items, itemsPosition, images, imagesPosition, networks, networkImages, DataTableCalendarDetail, selectedMonth, currentDate } = this.state;

    const calendarDays = this.generateCalendarDays(currentDate, DataTableCalendarDetail);

    return (
      <div
      className={styles.pageContainer}
      style={{ backgroundColor: '#002A66' }}
      // style={{ backgroundImage: "url('/images/img__3.png')",
      // backgroundAttachment: 'fixed',
      // backgroundSize: 'cover' }}
      >
        <Header />

        {this.state.newsGroups.length > 1 && (<Container id="newsSectionContainer" className="mt-4">
            <Container fluid className="news-section px-4 py-5 position-relative">
                {/* <Row className="mb-4">
                <Col>
                {this.state.newsGroups.length > 1 && (
                    <>
                    <h2 className="news-title mb-3">{`ประชาสัมพันธ์`+this.state.newsGroups[this.state.activeGroupIndex].groupName || 'ประชาสัมพันธ์'}</h2>
                    <p className="news-description">
                        {this.renderNewsDescription(this.state.newsGroups[this.state.activeGroupIndex].groupName)}
                    </p>
                    </>
                )}
                </Col>
                </Row> */}

            <Row className="gx-4">
            {/* ซ้าย: list ข่าว */}
            {this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.length > 1 && (
            <Col lg={6}>
                <Card className="news-list-box p-4 shadow-sm border-0 d-flex flex-column justify-content-between" style={{ minHeight: '540px' }}>
                <div>
                    {this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.slice(1).map((item) => (
                    <Row key={item.id} className="mb-4 gx-3 align-items-start" onClick={() => this.props.navigate(`/publicize/news/${item?.source_type}/${item?.id}`)}>
                        <Col xs={5}>
                        <CommonImageFrontend
                            src={this.state.DatatableImage1?.[item.id] || null}
                            alt="ประชาสัมพันธ์"
                            style={{
                            width: '100%',
                            height: '120px',
                            objectFit: 'cover',
                            borderRadius: '6px'
                            }}
                        />
                        </Col>
                        <Col xs={7}>
                        <div className="d-flex align-items-center gap-2 mb-1">
                            <span className="text-muted small">
                            {item.publicize_date && util.convertDateToTextBE(item.publicize_date)}
                            </span>
                            <div className="vr" style={{ height: '12px' }}></div>
                            <span className="text-muted small">ล่าสุด</span>
                        </div>
                        <h5 className="news-item-title mb-2">{util.truncateText(item?.name, 80)}</h5>
                        <p className="small text-body">{util.truncateText(item?.detail, 150)}</p>
                        </Col>
                    </Row>
                    ))}
                </div>
                </Card>
            </Col>
            )}


            {/* ขวา: ข่าวเด่น */}
            <Col
            lg={
                this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.length > 1
                ? 6
                : 12
            }
            >
            {/* {this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.length > 0 && ( */}
                <Card
                className="featured-box text-white border-0 overflow-hidden position-relative p-0"
                onClick={() => {
                    const item =
                    this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0];
                    if (item?.id && item?.source_type) {
                    this.props.navigate(`/publicize/news/${item.source_type}/${item.id}/test`);
                    }
                }}
                >
                <div
                    style={{
                    backgroundImage: `url(${
                        this.state.DatatableImage1?.[
                        this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                            ?.id
                        ] || '/images/default-image.jpg'
                    })`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '540px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    filter: 'brightness(0.7)',
                    }}
                    className="rounded w-100"
                >
                    <div className="featured-overlay p-4 w-100">
                    <Button className="text-white btn-outline-light mb-3" size="sm">
                        ข่าวเด่น
                    </Button>
                    <p className="text-white mb-2">
                        {util.convertDateToTextBE(
                        this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                            ?.publicize_date
                        )}
                    </p>
                    <h3 className="featured-title text-white fw-bold">
                        {
                        this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                            ?.name
                        }
                    </h3>
                    <p className="text-white mt-2">
                        {util.truncateText(
                        this.state.newsGroups?.[this.state.activeGroupIndex]?.items?.[0]
                            ?.detail || '',
                        120
                        )}
                    </p>
                    </div>
                </div>
                </Card>
                {/* })} */}
            </Col>

            </Row>

                {/* ปุ่มเลื่อนซ้ายขวา */}
                    {/* <button
                        onClick={() =>
                        this.setState({
                            activeGroupIndex:
                            (this.state.activeGroupIndex - 1 + this.state.newsGroups.length) %
                            this.state.newsGroups.length,
                        })
                        }
                        className="prevButton"
                        style={{
                        position: 'absolute',
                        top: '50%',
                        left: '-20px',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        }}
                    >
                        <img
                        src="/images/img_arrowleft.svg"
                        alt="Previous"
                        width={32}
                        height={32}
                        />
                    </button>

                    <button
                        onClick={() =>
                        this.setState({
                            activeGroupIndex:
                            (this.state.activeGroupIndex + 1) % this.state.newsGroups.length,
                        })
                        }
                        className="nextButton"
                        style={{
                        position: 'absolute',
                        top: '50%',
                        right: '-20px',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        }}
                    >
                        <img
                        src="/images/img_arrowright.svg"
                        alt="Next"
                        width={32}
                        height={32}
                        />
                    </button> */}
                {/* end ปุ่มเลื่อนซ้ายขวา */}

                {/* จุด Indicator สำหรับข่าว */}
                {(<div
                    className="position-absolute bottom-0 start-50 translate-middle-x d-flex align-items-center gap-3 mb-4"
                    style={{ zIndex: 10 }}
                >
                    {this.state.newsGroups.map((_, idx) => (
                    <div
                        key={idx}
                        onClick={() => this.setState({ activeGroupIndex: idx })}
                        className={`rounded-circle cursor-pointer ${
                        idx === this.state.activeGroupIndex ? 'bg-dark' : 'bg-secondary bg-opacity-25'
                        }`}
                        style={{
                        width: '10px',
                        height: '10px',
                        transition: 'all 0.5s ease-in-out',
                        }}
                    ></div>
                    ))}
                </div>)}

            {!this.state.isMobile &&  (<button
                onClick={() =>
                this.setState({
                    activeGroupIndex:
                    (this.state.activeGroupIndex - 1 + this.state.newsGroups.length) %
                    this.state.newsGroups.length,
                })
                }
                className="nav-circle-button prevButton"
                style={{ left: window.innerWidth <= 768 ? "16px" : "-30px" }}
            >
                <i className="fa-solid fa-chevron-left"></i>
            </button>)}
            
            {!this.state.isMobile && (<button
                onClick={() =>
                this.setState({
                    activeGroupIndex:
                    (this.state.activeGroupIndex + 1) % this.state.newsGroups.length,
                })
                }
                className="nav-circle-button nextButton"
                style={{ right: window.innerWidth <= 768 ? "16px" : "-30px" }}
            >
                <i className="fa-solid fa-chevron-right"></i>
            </button>)}
                </Container>
            </Container>)
        }

        {/* หลักสูตร */}
        <Container className="my-5">
        <section
                  className="position-relative"
                  style={{
                    // backgroundImage: "url('/images/img_.png')",
                    // backgroundColor: '#003177',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  {/* <div className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      // backgroundColor: 'rgba(255, 255, 255, 0.85)',
                      zIndex: 1,
                  }}></div> */}
                  {/* หลักสูตร */}
                  <div className="position-relative" style={{ zIndex: 2 }}>
                    <Row className="mb-4">
                      <Col>
                        <h2 className="news-title mb-3"
                        >หลักสูตร</h2>
                        <p className="news-description"
                        // style={{ color: '#ffffff' }}
                        >
                          "หลักสูตร EEC คือโปรแกรมอบรมที่เน้นการปฏิบัติจริง เพื่อเพิ่มทักษะด้านเทคโนโลยีและนวัตกรรมพร้อมหลักสูตรที่ตอบโจทย์ภาคอุตสาหกรรม"
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      
                        <Col lg={6}>
                        <div className="bg-light rounded shadow-sm p-4">
                            {/* Calendar Header */}
                            <div className="d-flex align-items-center justify-content-between mb-4">
                            <img
                                src="/images/img_chevron.svg"
                                alt="Previous Month"
                                width={44}
                                height={44}
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.changeMonth(-1)}
                            />
                            <h3 className="text-uppercase fw-medium m-0" style={{ fontSize: '2rem', color: '#0E3362'}}>
                                {this.getMonthName(currentDate)}
                            </h3>
                            <img
                                src="/images/img_chevron_blue_gray_900.svg"
                                alt="Next Month"
                                width={44}
                                height={44}
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.changeMonth(1)}
                            />
                            </div>
            
                            <table className="w-100">
                            {/* Week Days */}
                            <thead>
                                <tr className="text-center">
                                {weekDays.map((day, idx) => (
                                    <th key={idx} className="px-1">
                                    <span className="fw-medium text-secondary small">{day}</span>
                                    </th>
                                ))}
                                </tr>
                            </thead>
                                
                            {/* Calendar Grid */}
                            <tbody>
                                {Array.from({ length: Math.ceil(calendarDays.length / 7) }).map((_, rowIndex) => {
                                const rowDays = calendarDays.slice(rowIndex * 7, rowIndex * 7 + 7);
                                
                                return (
                                    <tr key={rowIndex}>
                                    {rowDays.map((dayData, index) => (
                                        <td
                                        key={index}
                                        className="border text-center"
                                        style={{
                                            height: "64px",
                                            width: "72px",
                                            backgroundColor: dayData.isOtherMonth
                                            ? "var(--global-bg-11)"
                                            : "var(--global-bg-17)"
                                        }}
                                        >
                                        <span
                                            className="small"
                                            style={{
                                            display: "inline-block",
                                            width: "32px",
                                            height: "32px",
                                            lineHeight: "32px",
                                            textAlign: "center",
                                            borderRadius: "50%",
                                            backgroundColor: dayData.hasEvent && !dayData.isOtherMonth
                                                ? "#f99e39"
                                                : "transparent",
                                            color: dayData.isOtherMonth
                                                ? "#b5b5b5"
                                                : dayData.hasEvent
                                                ? "#fff"
                                                : "#0E3362",
                                            opacity: dayData.isOtherMonth ? 0.4 : 1,
                                            fontWeight: dayData.isOtherMonth ? 400 : 500,
                                            cursor: dayData.isOtherMonth ? "default" : "pointer",
                                            }}
                                        >
                                            {dayData.day}
                                        </span>
                                        </td>
                                    ))}
                                    </tr>
                                );
                                })}
                            </tbody>
                            </table>
                        </div>
                        </Col>
        
                      <Col lg={6}>
                        <Card className="news-list-box shadow-sm border-0">
                          <Card.Header className="bg-white fw-bold" style={{color: '#0E3362'}}>
                            {(`จำนวน `+util.renderText(DataTableCalendarDetail?.length))+` หลักสูตร ที่กำลังอบรม`}
                          </Card.Header>
                          <Card.Body className="px-4" style={{ minHeight: '478px', maxHeight: '478px', overflowY: 'auto' }}>
                            {DataTableCalendarDetail?.map((item, index) => 

                            (<Row key={item.id} className="mb-4 gx-3 align-items-start"
                              style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'transparent' }}
                              >
                                <Col xs={2} className="d-flex justify-content-center align-items-start pt-1">
                                  <span
                                    className="d-flex justify-content-center align-items-center"
                                    style={{
                                      width: window.innerWidth <= 768 ? '30px' : '60px',
                                      height: window.innerWidth <= 768 ? '30px' :  '60px',
                                      borderRadius: '50%',
                                      // backgroundColor: '#faad14',
                                      backgroundColor: '#0E3362',
                                      color: 'white',
                                      fontSize: window.innerWidth <= 768 ? '1rem' : '1.25rem',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {index + 1}
                                  </span>
                                </Col>
        
                                <Col xs={10}>
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                      {(item.training_start_date) && (`อบรมตั้งแต่วันที่ `+util.convertDateToTextBE(item.training_start_date	))}
                                    <div className="vr" style={{ height: '12px' }}></div>
                                      {(item.training_end_date) && (`สิ้นสุดวันที่ `+util.convertDateToTextBE(item.training_end_date	))}
                                  </div>
        
                                  <h5 className="news-item-title text-orange mb-2">{item.course_eb_02_name}</h5>
                                  <p className="small text-body">{item?.detail?.length > 270 ? item.detail.substring(0, 270) + '...' : item?.detail}</p>
                                  <p className="small text-body">{item.academy_name ? `สถานศึกษา : ${util.renderText(item.academy_name)}` : ''}</p>
                                  <p className="small text-body">{item.target_industries_name ? `อุตสหากรรมเป้าหมาย : ${util.renderText(item.target_industries_name)}` : ''}</p>
                                  <p className="small text-body">{item.keyword ? `คีย์เวิร์ด : ${util.renderText(item.keyword)}` : ''}</p>
                                  <hr/>
                                </Col>
                              </Row>)
                              
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </section>
        </Container>


        {/* ข่าวประชาสัมพันธ์ */}
        <Container className="my-5">

          <Row className="mb-5 mt-10">
            <Col>
              <h2 className="news-title mb-3">ข่าวประชาสัมพันธ์</h2>
              <p className="news-description">
                ติดตามข้อมูลข่าวสารและกิจกรรมต่าง ๆ ที่น่าสนใจจากเขตพัฒนาพิเศษภาคตะวันออก
              </p>
            </Col>
          </Row>

          <Row className="gx-4 gy-4">
            {items.map((item) => (
              <Col md={6} key={item?.id}>
                <Card className="shadow-sm h-100 border-0 p-3 d-flex flex-row align-items-start" onClick={() => this.props.navigate('news/' + item.source_type + '/' + item?.id)} style={{ cursor: 'pointer' }}>
                  <CommonImageFrontend
                    src={images?.[item?.id] || null}
                    alt="ประชาสัมพันธ์"
                    style={{ width: '120px', height: '120px', objectFit: 'cover', marginRight: '16px' }}
                  />
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">
                      {util.convertDateToTextBE(item?.publicize_date)}
                    </small>
                    <h5 className="fw-semibold mb-2">{item?.name}</h5>
                    <p className="small text-muted mb-0">{item?.detail?.length > 270 ? item.detail.substring(0, 270) + '...' : item?.detail}
                    </p>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button onClick={this.handlePrevPage} variant="outline-primary" disabled={this.state.page <= 1}>
              &laquo; ก่อนหน้า
            </Button>
            <span className="text-muted">
              หน้า {this.state.page} จาก {this.state.totalPages}
            </span>
            <Button onClick={this.handleNextPage} variant="outline-primary" disabled={this.state.page >= this.state.totalPages}>
              ถัดไป &raquo;
            </Button>
          </div>
        </Container>

        <section
          className="position-relative py-5"
          // style={{
          //   backgroundImage: "url('/images/img_.png')",
          //   backgroundSize: 'cover',
          //   backgroundPosition: 'center',
          // }}
        >
          {/* <div className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              zIndex: 1,
          }}></div> */}
        {/* หลักสูตรอบรม */}
        {/* <Container className="position-relative my-5 mt-10" style={{ zIndex: 2 }}>
          <Row className="mb-4 mt-10">
            <Col>
              <h2 className="news-title mb-3">หลักสูตรอบรม</h2>
              <p className="news-description">
                รายการอบรมและพัฒนาทักษะที่เปิดให้กับแรงงานในพื้นที่ EEC
              </p>
            </Col>
          </Row>

          <Row className="gx-4 gy-4">
            {this.state.courses.map((item) => (
              <Col md={6} key={item?.id}>
                <div className="d-flex flex-row shadow-sm border rounded bg-light p-3 h-100">
                  
                  <img
                    src="/images/EEC-logo-yt.png" // ใช้รูปเดียวกันทุกอัน
                    alt="Course"
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '6px',
                      // flexShrink: 0,
                      marginRight: '16px'
                    }}
                  />
                  
                  <div className="flex-grow-1">
                    <h5 className="fw-semibold mb-2">{item?.th_name}</h5>
                    <p className="small text-muted mb-0">{item?.detail}</p>
                    {item?.academy_name && (
                      <p className="small text-muted mb-0">สถานศึกษา: {util.renderText(item?.academy_name)}</p>
                    )}
                    {item?.target_industries_name && (
                      <p className="small text-muted mb-0">อุตสาหกรรมเป้าหมาย: {util.renderText(item?.target_industries_name)}</p>
                    )}
                    {item?.target_group && (
                      <p className="small text-muted mb-0">กลุ่มเป้าหมาย: {util.renderText(item?.target_group)}</p>
                    )}
                    {item?.keyword && (
                      <p className="small text-muted mb-0">คีย์เวิร์ด: {util.renderText(item?.keyword)}</p>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>


          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button
              onClick={() => this.setState((prev) => ({ coursePage: Math.max(prev.coursePage - 1, 1) }), this.loadTrainingCourseData)}
              variant="outline-primary"
              disabled={this.state.coursePage <= 1}
            >
              &laquo; ก่อนหน้า
            </Button>
            <span className="text-muted">
              หน้า {this.state.coursePage} จาก {this.state.courseTotalPages}
            </span>
            <Button
              onClick={() => this.setState((prev) => (prev.coursePage < prev.courseTotalPages ? { coursePage: prev.coursePage + 1 } : null), this.loadTrainingCourseData)}
              variant="outline-primary"
              disabled={this.state.coursePage >= this.state.courseTotalPages}
            >
              ถัดไป &raquo;
            </Button>
          </div>
        </Container> */}
        </section>

        {/* ตำแหน่งงานที่ต้องการ */}
        <Container className="my-5">

          <Row className="mb-5 mt-10">
            <Col>
              <h2 className="news-title mb-3">ประชาสัมพันธ์ตำแหน่งงาน</h2>
              <p className="news-description">
                รายการตำแหน่งงาน และผู้ประกอบการซึ่งกำลังเปิดรับสมัครอยู่ในขณะนี้
              </p>
            </Col>
          </Row>
          <Row className="gx-4 gy-4" >
            {itemsPosition.map((item) => (
              <Col md={6} key={item?.id}>
                <Card className="shadow-sm h-100 border-0 p-3 d-flex flex-row align-items-start" onClick={() => this.props.navigate('news/'+item.source_type+'/'+item?.id)} style={{ cursor: 'pointer' }}> 
                  <CommonImageFrontend
                    src={imagesPosition?.[item?.id] || null}
                    alt="ประชาสัมพันธ์"
                    style={{ width: '120px', height: '120px', objectFit: 'cover', marginRight: '16px' }}
                  />
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">
                      {util.convertDateToTextBE(item?.publicize_date)}
                    </small>
                    <h5 className="fw-semibold mb-2">{`ตำแหน่ง: `+item?.position_name}</h5>
                    <p className=" text-muted mb-0">{`จำนวน: `+item?.people_count+` อัตรา`}</p>
                    <p className=" text-muted mb-0">{`หน่วยงาน/บริษัท: `+item?.operator_name}</p>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button onClick={this.handlePrevPage} variant="outline-primary" disabled={this.state.page <= 1}>
              &laquo; ก่อนหน้า
            </Button>
            <span className="text-muted">
              หน้า {this.state.page} จาก {this.state.totalPages}
            </span>
            <Button onClick={this.handleNextPage} variant="outline-primary" disabled={this.state.page >= this.state.totalPages}>
              ถัดไป &raquo;
            </Button>
          </div>
        </Container>

        {/* ศูนย์เครือข่าย */}
        {/* <section
          className="position-relative py-5"
          // style={{
          //   backgroundImage: "url('/images/img_0.png')",
          //   backgroundSize: 'cover',
          //   backgroundPosition: 'center',
          // }}
        > */}
          {/* <div className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              zIndex: 1,
          }}></div> */}
          {/* <Container  className="position-relative my-5 mt-10" style={{ zIndex: 2 }}>
            <Row className="mb-4 mt-10">
              <Col>
                <h2 className="news-title mb-3">ศูนย์เครือข่าย</h2>
                <p className="news-description">
                  แหล่งรวมความร่วมมือและพันธมิตรในเขตพัฒนาพิเศษภาคตะวันออก เพื่อขับเคลื่อนเศรษฐกิจและนวัตกรรม
                </p>
              </Col>
            </Row>

            <Row className="gx-4 gy-4">
              {networks.map((item) => (
                <Col md={6} key={item?.id}>
                  <Card className="shadow-sm h-100 border-0 p-3 d-flex flex-row align-items-start" onClick={() => this.props.navigate('eec/'+item?.id)}>
                    <CommonImageFrontend
                      src={networkImages?.[item?.id] || null}
                      alt="ศูนย์เครือข่าย"
                      style={{ width: '120px', height: '120px', objectFit: 'cover', marginRight: '16px' }}
                    />
                    <div className="flex-grow-1">
                      <small className="text-muted d-block mb-1">{item?.partner_name}</small>
                      <h5 className="fw-semibold mb-2">{item?.name}</h5>
                      <p className="small text-muted mb-0">{util.truncateText(item?.description,70)}</p>
                      
                      <p className="small text-muted mb-0"><img src="/images/img_location.svg" alt="Location" className="me-2" width={16} height={16} />{util.truncateText(item?.location	,140)}</p>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section> */}
        <Footer />
      </div>
    );
  }
}

export default withRouter(PublicizePage);
